const de = {
  nav: {
    home: 'Home',
    artisanBreads: 'Artisan-Brot',
    portfolio: 'Portfolio',
    gallery: 'Galerie',
    shop: 'Shop',
    contact: 'Kontakt',
  },
  imageStrip: {
    freshFromOven: 'Frisch aus dem Ofen',
    breadTable: 'Die Brottafel',
  },
  gallery: {
    all: 'Alle',
    breads: 'Brote',
    foodDrinks: 'Essen und Getränke',
      catering: 'Catering',
      kozunak: 'Kozunak',
  },
  menu: {
    bar: 'Bar',
    barSubtitle: 'Cocktails und mehr',
    catering: 'Snacks',
    cateringSubtitle: 'Berlin',
    artisanBreads: 'Hausgemachtes Artisan-Brot',
    artisanBreadsSubtitle: 'Brot und Gebäck',
    hotDrinks: 'Heißgetränke',
    hotDrinksSubtitle: 'Kaffee-Fantasien',
    desserts: 'Desserts',
    dessertsSubtitle: 'Kuchen und Gebäck',
  },
  pages: {
    menu: {
      heroLabel: 'Menü',
      heroTitle: 'Speisen und Getränke',
      heroText: 'Hausgemachtes Essen, warme Getränke und handwerkliches Brot mit Sorgfalt zubereitet.',
      heroPassion: 'Echte Leidenschaft',
      heroFlavours: 'Natürliche Aromen',
      introLabel: 'Grain Bites',
      introTitle: 'Wählen Sie Ihren Favoriten',
      introText: 'Einfache Zutaten, großzügige Portionen und etwas Gutes für jede Stimmung.',
      showcaseTitle: 'Köstliches Menü',
      showcaseText: 'Die besten Angebote aus der Grain-Bites-Küche',
      menuItem: 'Menügericht',
      barTitle: 'Bar & Snacks',
      coffeeTitle: 'Kaffee',
      teaTitle: 'Tee',
      dessertsTitle: 'Desserts',
      viewAll: 'Alle ansehen',
      openMenu: 'Öffnen',
      openDetails: 'Details öffnen für',
      close: 'Details schließen',
      ingredientsLabel: 'Zutaten',
      descriptions: {
        bar: 'Sorgfältig zubereitete Getränke und kleine Happen für entspannte Momente.',
        coffee: 'Warme Kaffee-Klassiker, mit Sorgfalt für jeden Tag zubereitet.',
        tea: 'Eine Auswahl aromatischer Tees, warm serviert und zum Genießen.',
        desserts: 'Frisch zubereitete süße Köstlichkeiten für einen feinen Abschluss.',
      },
      featured: {
        breakfastTitle: 'Frühstücksmenü',
        breakfastText: 'Frischer Start von 8:00 bis 12:00 Uhr',
        lunchTitle: 'Mittagsmenü',
        lunchText: 'Gutes Essen für eine entspannte Mittagspause',
      },
      columns: {
        breakfast: 'Frühstück',
        lunch: 'Mittagessen',
      },
      items: {
        morningEggToast: 'Morgentoast mit Ei',
        breakfastPlate: 'Frühstücksteller',
        sweetKozunak: 'Süßer Kozunak',
        seasonalPlate: 'Saisonaler Teller',
        grainBowl: 'Getreide-Bowl',
        sharedTable: 'Gemeinsame Tafel',
        warmLunchPlate: 'Warmer Mittagsteller',
        sweetFinish: 'Süßer Abschluss',
      },
      ingredients: {
        morningEggToast: 'Sauerteigbrot / Ei / Butter / saisonales Grün',
        breakfastPlate: 'Eier / Sauerteigbrot / Grün / Kräuter',
        sweetKozunak: 'Ei / Butter / Zitrusfrüchte / Weizenmehl',
        seasonalPlate: 'Frisches Gemüse / Kräuter / Hausdressing',
        grainBowl: 'Getreide / Grün / geröstetes Gemüse',
        sharedTable: 'Brot / Aufstriche / Gemüse / Kräuter',
        warmLunchPlate: 'Getreide / geröstetes Gemüse / Kräuter',
        sweetFinish: 'Frisches Obst / Gebäck / Hauscreme',
      },
    },
    contact: {
      eyebrow: 'Grain Bites',
      title: 'Kontakt',
      intro: 'Sprechen wir über Ihre nächste Veranstaltung, Speisekarte oder Catering-Idee.',
      sectionLabel: 'Besuchen Sie uns',
      heading: 'Kommen Sie vorbei',
      description: 'Wir freuen uns, von Ihnen zu hören und etwas Köstliches zu gestalten.',
      sendLabel: 'Nachricht senden',
      formTitle: 'Was können wir für Sie tun?',
      name: 'Name',
      email: 'E-Mail',
      message: 'Nachricht',
      send: 'Nachricht senden',
      sending: 'Wird gesendet...',
      success: 'Danke — Ihre Nachricht wurde gesendet.',
      error: 'Ihre Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    },
    blogPost: {
      label: 'Grain Bites Journal',
      title: 'Warum Sauerteig Zeit braucht',
      intro: 'Ein genauerer Blick auf Fermentation, Geschmack und das Handwerk hinter jedem Laib.',
      overviewTitle: 'Warum Sauerteig Zeit braucht',
      overviewIntro: 'Ein genauerer Blick auf Fermentation, Geschmack und das Handwerk hinter jedem Laib.',
      basicsTitle: 'Was ist Sauerteig?',
      basicsIntro: 'Wie Mehl, Wasser, wilde Hefen und Zeit zu Brot mit Charakter werden.',
      benefitsTitle: 'Die Vorteile von Sauerteig',
      benefitsIntro: 'Warum natürlich fermentiertes Brot voller Geschmack und besonders bekömmlich ist.',
      processTitle: 'Vom Anstellgut bis zur Kruste',
      processIntro: 'Die geduldigen Schritte vom aktiven Anstellgut bis zum Laib mit goldener Kruste.',
      back: 'Zurück zum Journal',
      notFound: 'Diese Geschichte wurde nicht gefunden.',
      published: 'Veröffentlicht',
      contentsFermentation: 'Fermentation schafft Charakter',
      contentsCrust: 'Vom Anstellgut bis zur Kruste',
      categoryBread: 'Artisan-Brot',
      categorySourdough: 'Sauerteig',
      categoryTea: 'Tee & Momente',
      categoryMenu: 'Essen & Getränke',
      fermentationTitle: 'Fermentation schafft Charakter',
      fermentationIntro: 'Wie eine langsame Fermentation Aroma, Struktur und Tiefe im Sauerteig entwickelt.',
      crustTitle: 'Vom Anstellgut bis zur Kruste',
      crustIntro: 'Die geduldigen Schritte vom aktiven Anstellgut bis zum Laib mit goldener Kruste.',
      contentsFermentationHow: 'So funktioniert Fermentation',
      contentsFermentationTime: 'Zeit und Temperatur',
      contentsCrustStarter: 'Das Anstellgut auffrischen',
      contentsCrustBake: 'Den Laib backen',
      overviewContentsTrend: 'Mehr als nur ein Trend',
      overviewContentsWhat: 'Was ist Sauerteig?',
      overviewContentsBenefits: 'Vorteile von Sauerteig',
      overviewContentsCrust: 'Vom Anstellgut bis zur Kruste',
      contentsBasicsWhat: 'Was ist Sauerteig?',
      contentsBasicsTrend: 'Warum Sauerteig wichtig ist',
      contentsBenefitsCharacter: 'Geschmack und Charakter',
      contentsProcessPatience: 'Geduld im Prozess',
      contentsProcessBake: 'Vom Teig bis zur Kruste',
    },
    artisanBreads: {
      eyebrow: 'Grain Bites',
      title: 'Hausgemachtes Artisan-Brot & Gebäck',
      intro: 'Hausgemachtes Artisan-Brot und frisches Gebäck aus einfachen Zutaten, sorgfältigen Händen und viel Zeit.',
      tagline: 'Vom lebendigen Sauerteig bis zur goldenen Kruste',
      sectionLabel: 'Frisch aus dem Ofen',
      heading: 'Gutes Brot braucht Zeit',
      description: 'Unsere handwerkliche Brotauswahl ist für große Tafeln, entspannte Morgen und besondere Zusammenkünfte gemacht. Jeder Laib wird sorgfältig zubereitet und frisch serviert.',
      sourdoughTitle: 'Brotbacken mit Sauerteig ist mehr als nur ein Trend',
      sourdoughIntro: 'Es ist die Rückkehr zu einer jahrhundertealten Handwerkskunst. Wer sein Brot mit Sauerteig selbst backt, erlebt nicht nur den unvergleichlichen Duft frisch gebackenen Brotes, sondern profitiert auch von zahlreichen gesundheitlichen Vorteilen und einem einzigartigen Geschmackserlebnis.',
      sourdoughLabel: 'Sauerteig',
      sourdoughWhatTitle: 'Was ist Sauerteig?',
      sourdoughWhatText: 'Sauerteig ist eine natürliche Mischung aus Mehl und Wasser, die durch Milchsäurebakterien und wilde Hefen in Gärung gerät. Dieser Fermentationsprozess sorgt dafür, dass das Brot auf natürliche Weise aufgeht – ganz ohne künstliche Triebmittel wie Hefe. Durch die lange Reifezeit entwickeln sich intensive Aromen und eine besonders bekömmliche Krume.',
      sourdoughBenefitsTitle: 'Vorteile von Sauerteigbrot',
      sourdoughBenefits: [
        'Natürliche Haltbarkeit: Sauerteig wirkt wie ein natürliches Konservierungsmittel – dein Brot bleibt länger frisch.',
        'Bessere Verträglichkeit: Durch den Abbau von Phytinsäure ist Sauerteigbrot leichter verdaulich und nährstoffreicher.',
        'Einzigartiger Geschmack: Die Kombination aus milden und leicht säuerlichen Noten macht jedes Brot zu einem aromatischen Genuss.',
        'Gesunde Zutaten: Keine Zusatzstoffe, keine Industriehefe – nur Mehl, Wasser, Salz und Zeit.',
      ],
      sourdoughCtaTitle: 'Die Welt des Sauerteigs entdecken',
      sourdoughCtaText: 'Erfahre mehr über Fermentation, Geschmack und das Handwerk hinter jedem Laib.',
      sourdoughCtaLink: 'Sauerteig entdecken',
      sourdoughPageTitle: 'Der Sauerteig-Ratgeber',
      sourdoughPageIntro: 'Ein genauerer Blick auf Fermentation, Geschmack und die Kunst hinter jedem Laib.',
      sourdoughBack: 'Zurück zum Artisan-Brot',
      sourdoughTopicsLabel: 'Sauerteig-Themen',
      sourdoughTopics: {
        overview: 'Sauerteig',
        basics: 'Was ist Sauerteig?',
        benefits: 'Vorteile',
        process: 'Vom Anstellgut zur Kruste',
      },
      slowPreparation: 'Langsame Zubereitung',
      slowPreparationText: 'Zeit für Textur und Geschmack.',
      madeForSharing: 'Zum Teilen gemacht',
      madeForSharingText: 'Perfekt für Frühstück und Catering.',
      planOrder: 'Bestellung planen',
      collection: 'Die Auswahl',
      galleryTitle: 'Zum Teilen gebacken',
      viewDetails: 'Details ansehen',
      close: 'Produktdetails schließen',
      ingredients: 'Zutaten',
      categories: {
        wholegrain: 'Vollkorn',
        white: 'Weißbrot',
        goldenGrain: 'Goldenes Korn',
        dinkel: 'Dinkel',
        mixes: 'Mischungen',
        dinkelRye: 'Dinkel-Roggen',
        kozunak: 'Kozunak',
      },
    },
    portfolio: {
      eyebrow: 'Grain Bites',
      title: 'Portfolio',
      introHeading: 'Eine Auswahl unserer Arbeit',
      introText: 'Bars, Catering-Tafeln, handwerkliches Brot und Veranstaltungen, mit Sorgfalt im Geist von Kreuzberg gestaltet.',
      projects: {
        bar: {
          label: 'Bar & Getränke',
          title: 'Cocktailbar-Erlebnisse',
          text: 'Eine entspannte Bar-Atmosphäre mit ausgewählten Getränken, herzlichem Service und einem Ort für gute Gespräche.',
          imageAlt: 'Bar-Atmosphäre von Grain Bites',
        },
        catering: {
          label: 'Catering',
          title: 'Tafeln zum Teilen',
          text: 'Von Geschäftsessen bis zu privaten Feiern gestalten wir großzügige Tafeln, die Menschen bei frischem Essen zusammenbringen.',
          imageAlt: 'Catering-Tafel von Grain Bites',
        },
        bread: {
          label: 'Artisan-Brot',
          title: 'Frisch aus dem Ofen',
          text: 'Hausgemachtes Brot und Gebäck verleihen jedem Menü und jeder Veranstaltung einen warmen, unvergesslichen Mittelpunkt.',
          imageAlt: 'Frisches handwerkliches Brot',
        },
        events: {
          label: 'Veranstaltungen',
          title: 'Essen mit Ortsgefühl',
          text: 'Wir gestalten jede Veranstaltung passend zu ihren Menschen, ihrem Raum und den kleinen Details, die sie persönlich machen.',
          imageAlt: 'Veranstaltungsraum von Grain Bites',
        },
      },
    },
  },
};

export default de;
